export default __webpack_public_path__ + "assets/c0d4a616af24548db1ac59a1344aa8a7.svg";